import angular from 'angular';

const adServices = angular.module('applicationModule.adServices', []);

adServices.factory('Ad', ['AdAPI', function (AdAPI) {
    'use strict';

    return {
        get: (appId, params) => {
            return AdAPI.getAds(appId, params).then((response) => {
                return response.data;
            });
        },
        getOne: (adId, appId) => {
            return AdAPI.getAd(adId, appId);
        },
        save: (ad, editMode) => {
            if (editMode) {
                return AdAPI.editAd(ad);
            } else {
                return AdAPI.createAd(ad);
            }
        },
        remove: (adId) => {
            return AdAPI.removeAd(adId);
        }
    };
}]);

adServices.service('AdAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = `${AppsoupAPI.API_URL}/app/announcement/`;

    this.getAds = (appId, params) => {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.createAd = (ad) => {
        return $http.post(API_URL, ad);
    };

    this.getAd = (adId, appId) => {
        return $http.get(`${API_URL}${adId}`, {params: {application_id: appId}});
    };

    this.editAd = (ad) => {
        return $http.put(`${API_URL}${ad.id}`, ad);
    };

    this.removeAd = (adId) => {
        return $http.delete(`${API_URL}${adId}`);
    };

}]);

export default adServices;
